/**
 * Where each carrier's contracting goes after an agent requests it on Altura.
 * Admins change this on /dashboard/carriers (CarrierSetting rows); a carrier
 * with no row uses DEFAULT_CARRIER_ROUTES.
 *
 * Defaults follow Paul's answers on Oct 31: PPG is leaving and its carriers
 * move to Heartland (Reagan.AI); SMS carriers go through our SureLC with no
 * recruiting links; Pinnacle carriers go through our SureLC (no Spot form);
 * Aflac and American Home Life stay direct invites.
 */
import { Carrier, CARRIER_SLUG_TO_CARRIER, CARRIER_TO_IMO, IMO } from "./carriers.js";
export const CARRIER_ROUTES = ["SURELC", "REAGAN", "DIRECT_INVITE", "MANUAL"];
export const CARRIER_ROUTE_LABELS = {
    SURELC: "Insurance Bay (our SureLC)",
    REAGAN: "Reagan.AI invite",
    DIRECT_INVITE: "Direct carrier invite",
    MANUAL: "Manual (staff handles it)",
};
export function isCarrierRoute(value) {
    return typeof value === "string" && CARRIER_ROUTES.includes(value);
}
const PPG_TO_REAGAN = [
    Carrier.AMERICAN_AMICABLE,
    Carrier.COREBRIDGE,
    Carrier.ELCO_MUTUAL,
    Carrier.ROYAL_NEIGHBORS,
    Carrier.TRANSAMERICA,
];
const DIRECT_INVITE_DEFAULTS = [Carrier.AFLAC, Carrier.AMERICAN_HOME_LIFE];
function defaultRouteFor(carrier) {
    if (PPG_TO_REAGAN.includes(carrier))
        return "REAGAN";
    if (DIRECT_INVITE_DEFAULTS.includes(carrier))
        return "DIRECT_INVITE";
    const imo = CARRIER_TO_IMO[carrier];
    if (imo === IMO.HEARTLAND)
        return "REAGAN";
    if (imo === IMO.SMS || imo === IMO.PINNACLE)
        return "SURELC";
    return "MANUAL";
}
export const DEFAULT_CARRIER_ROUTES = Object.fromEntries(Object.values(Carrier).map((carrier) => [carrier, defaultRouteFor(carrier)]));
/** Accepts a Carrier enum value or the lowercase contract/form slug. */
export function toCarrier(value) {
    const trimmed = value.trim();
    if (!trimmed)
        return null;
    return (CARRIER_SLUG_TO_CARRIER[trimmed.toLowerCase()] ??
        (Object.values(Carrier).includes(trimmed) ? trimmed : null));
}
export function routeForCarrier(value, routes = {}) {
    const carrier = toCarrier(value);
    if (!carrier)
        return "MANUAL";
    return routes[carrier] ?? DEFAULT_CARRIER_ROUTES[carrier];
}
/** The carriers in `values` (slugs or enum values) that take `route`, de-duplicated, in input order. */
export function carriersOnRoute(values, route, routes = {}) {
    const out = [];
    for (const value of values) {
        const carrier = toCarrier(value);
        if (carrier && !out.includes(carrier) && routeForCarrier(carrier, routes) === route)
            out.push(carrier);
    }
    return out;
}
